import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {MapAddonModel} from "@/modules/redactor/models/map-addon/core/MapAddonModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {MapAddonType} from "@/modules/redactor/models/map-addon/core/MapAddonType";


export class MapAddonIslandModel extends MapAddonModel {

    constructor() {
        super(MapAddonType.ISLAND);

        this._priority = 0;
        this._product = null;
    }

    get priority() {
        return this._priority;
    }

    set priority(value) {
        this._priority = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    valid() {

        if (!Number.isInteger(this.priority) || this.priority < 0) {
            return false;
        }

        if (!this.product || !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.gameConfig) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapAddonIslandModel());
        } else if (target instanceof MapAddonIslandModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(MapAddonIslandModel, {
    _product: alias("product", Schema.primitive()),
    _priority: alias("priority", Schema.primitive())
});